import { useNavigate } from "react-router-dom";
import SocialHandles from "../SocialHandles/SocialHandles";
import logo from "../../Assets/images/Amn-Logo 1.svg";

export default function Footer() {
  const navigate = useNavigate();
  return (
    <div className="bg-primaryBG text-black pt-10 px-10 md:px-16 lg:px-20 font-nastaleeqRegular">
      {/* Top Section */}
      <div className="flex flex-col sm:flex-col md:flex-col lg:flex-row justify-end items-center lg:items-start text-center lg:text-end py-10 md:gap-x-12 lg:gap-x-24 lg:pb-20 border-b border-primary">
        <div className="mb-8 lg:mb-0 lg:order-2">
          <div className="flex justify-center items-center p-2">
            <img
              src={logo}
              alt="Logo"
              className="h-[100px] cursor-pointer"
              onClick={() => {
                navigate("/");
              }}
            />
          </div>
          <button
            className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl mb-3"
            onClick={() => {
              navigate("/");
            }}
          >
            ایسوسی ایشن آف مشتاقان نور(امن)
          </button>
          {/* <p className="text-grayFooter text-lg sm:text-xl md:text-2xl lg:text-2xl font-nastaleeqKasheeda">
                        پوسٹ آفس باکس نمبر ۲۵۵۲
                        <br /> اسلام آباد
                    </p> */}
        </div>
        <div className="flex flex-col-reverse sm:flex-col-reverse md:flex-col-reverse lg:flex-row gap-y-10 sm:gap-y-10 md:gap-y-10 lg:gap-y-0 lg:gap-x-20">
          {/* <div className="space-y-5">
                    <button
                        className="text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqKasheeda cursor-pointer text-primary"
                        onClick={() => {
                            navigate("/munasibat/jashnenoor");
                        }}
                    >
                        مناسبات
                    </button>
                    <div className="text-grayFooter text-md sm:text-lg md:text-lg lg:text-xl space-y-3">
                        <p
                            className="cursor-pointer hover:text-primary transition-colors duration-300"
                            onClick={() => navigate("/munasibat/jashnenoor")}
                        >
                            جشن نور
                        </p>
                        <p
                            className="cursor-pointer hover:text-primary transition-colors duration-300"
                            onClick={() => navigate("/munasibat/muharram")}
                        >
                            محرم الحرام
                        </p>
                        <p
                            className="cursor-pointer hover:text-primary transition-colors duration-300"
                            onClick={() => navigate("/munasibat/ayyamefatamiya")}
                        >
                            ایام فاطمیہ
                        </p>
                        <p
                            className="cursor-pointer hover:text-primary transition-colors duration-300"
                            onClick={() => navigate("/munasibat/exhibition")}
                        >
                            ایگزیبیشن
                        </p>
                    </div>
                </div> */}

          <div className="space-y-5">
            <button
              className="text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqKasheeda cursor-pointer text-primary"
              onClick={() => {
                navigate("/tazakurat");
              }}
            >
              تذکرات
            </button>
            <div className="text-grayFooter text-md sm:text-lg md:text-lg lg:text-xl space-y-3">
              <p
                className="cursor-pointer hover:text-primary transition-colors duration-300"
                onClick={() =>
                  navigate("/tazakurat", {
                    state: { selectedCategory: "یاد امام" },
                  })
                }
              >
                یاد امام
              </p>
              <p
                className="cursor-pointer hover:text-primary transition-colors duration-300"
                onClick={() =>
                  navigate("/tazakurat", {
                    state: { selectedCategory: "محاسبہ" },
                  })
                }
              >
                محاسبہ
              </p>
              <p
                className="cursor-pointer hover:text-primary transition-colors duration-300"
                onClick={() =>
                  navigate("/tazakurat", {
                    state: { selectedCategory: "محرم" },
                  })
                }
              >
                محرم
              </p>
              <p
                className="cursor-pointer hover:text-primary transition-colors duration-300"
                onClick={() =>
                  navigate("/tazakurat", {
                    state: { selectedCategory: "ایام فاطمیہ" },
                  })
                }
              >
                ایام فاطمیہ
              </p>
            </div>
          </div>

          <div className="space-y-5">
            <button
              className="text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqKasheeda text-primary cursor-pointer"
              onClick={() => navigate("/tableeghat/noordiary")}
            >
              تبلیغات
            </button>
            <div className="text-grayFooter text-md sm:text-lg md:text-lg lg:text-xl space-y-3">
              <p
                onClick={() => {
                  navigate("/tableeghat/noordiary");
                }}
                className="cursor-pointer hover:text-primary transition-colors duration-300"
              >
                نور ڈائری
              </p>
              <p
                onClick={() => {
                  navigate("/tableeghat/mujallah");
                }}
                className="cursor-pointer hover:text-primary transition-colors duration-300"
              >
                نور عصر مجلہ
              </p>
              <p
                onClick={() => {
                  navigate("/tableeghat/ourBooks");
                }}
                className="cursor-pointer hover:text-primary transition-colors duration-300"
              >
                مطبوعات
              </p>
            </div>
          </div>

          <div className="space-y-5">
            <button
              className="text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqKasheeda text-primary cursor-pointer"
              onClick={() => {
                navigate("/taaruf");
              }}
            >
              تعارف
            </button>
            <div className="text-grayFooter text-md sm:text-lg md:text-lg lg:text-xl space-y-3">
              <p
                onClick={() => navigate("/taaruf#amntaaruf")}
                className="cursor-pointer hover:text-primary transition-colors duration-300"
              >
                ہمارے بارے میں
              </p>
              <p
                onClick={() => navigate("/taaruf#classTarauf")}
                className="cursor-pointer hover:text-primary transition-colors duration-300"
              >
                کلاسز کا تعارف
              </p>
              <p
                onClick={() => navigate("/taaruf#classdarjat")}
                className="cursor-pointer hover:text-primary transition-colors duration-300"
              >
                کلاس کے درجات
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Section */}
      <div className="py-6 flex flex-col lg:flex-row justify-between items-center">
        {/* Social Media Links */}
        <SocialHandles />

        <div className="flex flex-col lg:flex-row items-center lg:items-start text-lg sm:text-xl md:text-xl lg:text-2xl space-y-2 lg:space-y-0">
          <span className="text-secondary lg:mr-2">
            ایسوسی ایشن آف مشتاقان نور (امن)
          </span>
          <p>تمام حقوق ویب سائٹ پر محفوظ ہیں۔</p>
          <p>۲۰۲۵</p>
        </div>
      </div>
    </div>
  );
}
